export const WYSIWYG_PATH = 'wysiwyg';
export const PREVIEW_PATH = 'tools/preview';
export const PREVIEW_PRESET_PATH = 'tools/preview/preset';
